import React from 'react';

import SectionContainer from 'components/Containers/SectionContainer';
import { Row } from 'components/Containers/Row/Row';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import Label from 'components/form/Label/Label';
import { TextBox } from 'components/form/TextBox';
import { Button } from 'components/form/Button';
import $t from 'locales/en/translation';
import { DropDown } from 'components/form/DropDown';
import { formatCurrency, formatUSD } from 'helpers/money.helper';
import './MonthlyPaymentCalculatorView.scss';

const PaymentCalculatorModuleView = props => {
  return (
    <SectionContainer className="monthlyCalculator">
      <Row>
        <Label
          datatestid={`${props.datatestid}-MonthlyPaymentCalculator-title`}
          type="H3"
          typeHeader={'h3'}
          className="margB24 m-margB20"
        >
          {$t.MonthlyPaymentCalculator}
        </Label>
        <Label
          datatestid={`${props.datatestid}-MonthlyPaymentCalculator-description`}
          type="Body-1"
          className="margB48 m-margB36"
        >
          {props?.config?.home_loan?.monthly_pay_calc?.subTitle}
        </Label>
        <FlexContainer className="flex-row flex-mobile-col">
          <TextBox
            datatestid={`${props.datatestid}-MonthlyPaymentCalculator-hp`}
            placeholder={$t.homePrice}
            value={formatCurrency(props.homePrice)}
            onChange={props.onHomePriceUpdate}
          />
          <div className="m-margB20 desktopOnlyHide" />
          <TextBox
            datatestid={`${props.datatestid}-MonthlyPaymentCalculator-dp`}
            placeholder={$t.downPayment}
            value={formatCurrency(props.downPayment)}
            onChange={props.onDownPaymentUpdate}
          />
          <div className="m-margB20 desktopOnlyHide" />
          <TextBox
            datatestid={`${props.datatestid}-MonthlyPaymentCalculator-ir`}
            placeholder={$t.interestRate}
            value={props.interestRate}
            onChange={props.onInterestRateUpdate}
          />
          <div className="m-margB20 desktopOnlyHide" />
          <DropDown
            datatestid={`${props.datatestid}-MonthlyPaymentCalculator-terms`}
            list={props.termsList}
            value={props.terms}
            onChange={e => props.setTerms(e)}
            label={$t.terms}
            defaultValue={props.termsList[0]}
            placeholder={$t.terms}
            id="monthlyPaymentCalculator-terms"
          />
        </FlexContainer>
        <FlexContainer className="flex-column">
          <div className="margT24 m-margT20 text-right format100 calcButton">
            <Button
              datatestid={`${props.datatestid}-MonthlyPaymentCalculator-calculate`}
              disabled={props.calculateButtonDisabled}
              mrphType="primary"
              onClick={props.handleCalculateMonthlyMortgageClick}
              className="border-rad100px"
            >
              {$t.calculate}
            </Button>
          </div>
          <FlexContainer className="flex-column">
            <Label
              datatestid={`${props.datatestid}-MonthlyPaymentCalculator-mp`}
              type="H2"
              className="text-36 margT40 m-margT50 text-center"
            >
              {formatUSD(props.monthlyPayment)}
            </Label>
            <Label
              datatestid={`${props.datatestid}-MonthlyPaymentCalculator-mp-description`}
              type="Body-1"
              className="text-center"
            >
              {$t.estimatedMonthlyPayment}
            </Label>
          </FlexContainer>
        </FlexContainer>
      </Row>
    </SectionContainer>
  );
};

export default PaymentCalculatorModuleView;
